// material-ui
import { useTheme } from "@mui/material/styles";
import { ThemeMode } from "types/config";

import logoDark from "assets/images/jobssy_logo.png";
import miniLogo from "assets/images/miniLogo.jpg";

import logo from "assets/images/jobssy_logo.png";
import { useGetMenuMaster } from "api/menu";

// ==============================|| LOGO SVG ||============================== //

const LogoMain = ({ reverse, ...others }: { reverse?: boolean }) => {
  const theme = useTheme();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  return (
    <img
      src={
        !drawerOpen
          ? miniLogo
          : theme.palette.mode === ThemeMode.DARK
          ? logoDark
          : logo
      }
      alt="Syria Jobs"
      width="100"
    />
  );
};

export default LogoMain;
